import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import authAxios from '@services/authAxios';

export const useGetProductList = ({ page, limit, search, id }) => {
    return useQuery({
        queryKey: ['product-list', { page, limit, search, id }],
        queryFn: async () => {
            const { data } = await authAxios.get(`/api/v1/promotion-claim/product-list`, {
                params: {
                    limit,
                    page,
                    search,
                    ...(id ? { promotion_id: id } : {}),
                },
            });
            return data;
        },
        select: ({ data }) => {
            const transformData = data?.page_data?.map((data) => ({
                ...data,
                id: data.sku_id ?? data.id,
                list_products: data?.list_products?.map((p) => ({
                    ...p,
                    sku_id: p.id,
                })),
            }));

            const res = { ...data, page_data: transformData };

            return res;
        },
        refetchOnWindowFocus: false,
        retry: false,
        gcTime: 0,
        enabled: !!id || !!search,
    });
};

const fetchSku = async ({ pageParam, queryKey }) => {
    const [_key, { search }] = queryKey;
    const { data } = await authAxios.get('/api/v1/promotion-claim/product-list', {
        params: { page: pageParam, limit: 20, search },
    });
    return data;
};

export const useGetInfiniteProductList = (search) => {
    return useInfiniteQuery({
        queryKey: ['product-list', { search }],
        queryFn: fetchSku,
        select: (data) => {
            const structuredData = data?.pages.flatMap((page) =>
                page.data.page_data.map((item) => ({
                    ...item,
                    id: item.sku_id,
                }))
            );
            return structuredData;
        },
        initialPageParam: 1,
        getNextPageParam: (lastPage, pages) => {
            if (lastPage?.data?.current_page < lastPage?.data?.total_page) {
                return lastPage?.data?.current_page + 1;
            }
            return undefined;
        },
        enabled: !!search,
    });
};
